@if (loading) {
  <app-loading class="app-loading"></app-loading>
}

@if (showDeliveryAnimation) {
  <div class="freshness-splash-overlay">
    <div class="splash-content">
      <div class="icon-wrapper">
        <!-- Thin-line grocery bag icon (using SVG for crispness) -->
        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          [style.stroke]="'#FB923C'">
          <path
            d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11M5 9H19L20 21H4L5 9Z"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <h1 class="splash-headline">Freshness, Delivered in 30 Minutes</h1>
      <p class="splash-subtext">From fruits to daily essentials — we bring the store to you.</p>
      <button class="splash-cta" (click)="onGetStarted()" [style.backgroundColor]="'#FB923C'">
        Get Started
      </button>
    </div>
  </div>
}

<!-- Custom Notification Modal -->
@if (showNotificationModal) {
  <div class="notification-modal-overlay" (click)="closeNotificationModal()">
    <div class="notification-modal-content" (click)="$event.stopPropagation()">
      <div class="notification-icon-wrapper">
        <div class="ringing-bell">🔔</div>
      </div>
      <h2 class="notification-title">{{ currentNotification?.title }}</h2>
      <p class="notification-body">{{ currentNotification?.body }}</p>
      <div class="notification-actions">
        <button class="btn-dismiss" (click)="closeNotificationModal()">Dismiss</button>
        <button class="btn-view" (click)="viewNotification()">View</button>
      </div>
    </div>
  </div>
}

@if (!loading) {
  <div>
    @if (!hideHeaderFooter) {
      <header class="header" [class.is-cart-checkout]="isCartOrCheckout">
        <a [href]="vHostUrl">
          <img [src]="data.primaryLogoLink" alt="" class="header-logo" />
        </a>
        @if (screenWidth > 774 && loggedIn) {
          <div (click)="onChangeAddress()" class="header-location" title="Change Delivery Location">
            <div class="location-icon-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="#ea580c">
                <path
                  d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z"></path>
              </svg>
            </div>
            <div class="location-text-group">
              <div class="location-title-row">
                <span class="deliver-label">Deliver to</span>
                @if (addressdata?.addressType) {
                  <span class="address-type-pill">{{ addressdata.addressType }}</span>
                }
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#64748b"
                  stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
              <p class="address-line">
                @if (addressdata) {
                  {{ addressdata?.city ? addressdata?.city + ', ' : ''
                  }}{{
                    addressdata?.landmark || addressdata?.locality || addressdata?.address || ''
                  }}
                } @else {
                  Select Location
                }
              </p>
            </div>
          </div>
        }
        @if (addressdata && screenWidth <= 774 && loggedIn) {
          <div class="mobile-location-bar" (click)="onChangeAddress()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="14"
              height="14"
              fill="#ea580c">
              <path
                d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995Z"></path>
            </svg>
            <span class="mobile-deliver-tag">Deliver to:</span>
            <p class="mobile-address">
              {{ addressdata?.city ? addressdata?.city + ', ' : ''
              }}{{ addressdata?.landmark || addressdata?.locality || addressdata?.address || '' }}
            </p>
            <mat-icon class="caret">expand_more</mat-icon>
          </div>
        }
        @if (!hideSearchBar) {
          <div class="header-search-row">
            <div class="header-search relative">
              <label for="search" class="sr-only">Search</label>
              @if (hideLayout) {
                <input
                  type="text"
                  id="search"
                  autocomplete="off"
                  [placeholder]="dynamicPlaceholder"
                  class="search-input"
                  [(ngModel)]="searchInput"
                  (keyup.enter)="onSearch()"
                  (keyup)="onSearchKeyup($event.target.value)" />
              }
              @if (!hideLayout) {
                <input
                  type="text"
                  id="search"
                  autocomplete="off"
                  [placeholder]="dynamicPlaceholder"
                  class="search-input"
                  [(ngModel)]="searchInput"
                  (click)="onClickSearchInput()" />
              }
              <div class="flex flex-row">
                @if (hasSpeechSupport) {
                  <button
                    type="button"
                    class="voice-search-btn"
                    [ngClass]="{ 'is-listening': isListening }"
                    (click)="onVoiceSearchClick()"
                    aria-label="Voice search"
                    [attr.aria-pressed]="isListening">
                    <div class="mic-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="currentColor">
                        <path
                          d="M12 2C10.6193 2 9.5 3.11929 9.5 4.5V11.5C9.5 12.8807 10.6193 14 12 14C13.3807 14 14.5 12.8807 14.5 11.5V4.5C14.5 3.11929 13.3807 2 12 2ZM7 9.5H8.5V11.5C8.5 13.9853 10.5147 16 13 16C15.4853 16 17.5 13.9853 17.5 11.5V9.5H19V11.5C19 14.3846 16.9463 16.7244 14.125 17.1844V20H16V22H8V20H9.875V17.1844C7.05372 16.7244 5 14.3846 5 11.5V9.5H7Z"></path>
                      </svg>
                    </div>
                  </button>
                }
                @if (searchInput.length) {
                  <button class="search-close" (click)="onSearchClear()">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="currentColor">
                      <path
                        d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                    </svg>
                  </button>
                }
                <button id="product-search" class="search-btn" (click)="onSearch()">
                  <svg
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor">
                    <path
                      d="M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.8675 18 18 14.8675 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z"></path>
                  </svg>
                </button>
              </div>
              @if (isSearchResultsVisible) {
                <ul
                  class="absolute left-0 top-8 w-full bg-white shadow-lg rounded-xl mt-2 max-h-96 overflow-y-auto z-[999]">
                  @if (isSearchLoading) {
                    @for (s of [1, 2, 3, 4, 5]; track s) {
                      <li class="flex items-center gap-3 p-3">
                        <div class="w-10 h-10 rounded-xl skeleton-shimmer"></div>
                        <div class="h-4 w-1/2 rounded-md skeleton-shimmer"></div>
                      </li>
                    }
                  }
                  @if (!isSearchLoading && searchResults?.length) {
                    @for (item of searchResults; track item) {
                      <li
                        (click)="onSelectProduct(item)"
                        class="flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-100 transition">
                        <img [src]="item.imageLink" class="w-10 h-10 rounded-xl object-cover" />
                        <span class="text-gray-800 font-medium">{{ item.productName }}</span>
                      </li>
                    }
                  }
                  @if (!isSearchLoading && !searchResults?.length) {
                    <div class="error-message flex flex-col items-center justify-center p-4">
                      <img
                        src="assets/images/no-data-found.png"
                        alt="no data"
                        class="w-20 h-20 mb-2" />
                      <p class="text-gray-600 font-medium text-center">
                        {{ errorMessage || 'No products found.' }}
                      </p>
                    </div>
                  }
                </ul>
              }
            </div>
            @if (screenWidth <= 774 && showFilterBtn) {
              <button class="filter-btn" (click)="onPriceFilter()">
                <i class="ri-equalizer-line"></i>
                <span>Sort</span>
              </button>
            }
          </div>
        }
        <div class="header-icons">
          @if (screenWidth > 820) {
            <button (click)="onCheckoutClick()">
              <span
                matBadge="15"
                matBadgeColor="warn"
                [matBadge]="cartItemCount"
                [matBadgeHidden]="cartItemCount === 0 || cartItemCount < 1"
                matBadgeOverlap="false"
                matBadgePosition="before"></span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="currentColor">
                <path
                  d="M4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V15H18.4433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z"></path>
              </svg>
            </button>
          }
          @if (!loggedIn && !hideSearchBar) {
            <button (click)="onSignin()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="currentColor">
                <path
                  d="M4 15H6V20H18V4H6V9H4V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V15ZM10 11V8L15 12L10 16V13H2V11H10Z"></path>
              </svg>
            </button>
          }
          @if (loggedIn) {
            <button [matMenuTriggerFor]="accountMenu">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="currentColor">
                <path
                  d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.1597 16C10.1243 16 8.29182 16.8687 7.01276 18.2556C8.38039 19.3474 10.114 20 12 20C13.9695 20 15.7727 19.2883 17.1666 18.1081C15.8956 16.8074 14.1219 16 12.1597 16ZM12 4C7.58172 4 4 7.58172 4 12C4 13.8106 4.6015 15.4807 5.61557 16.8214C7.25639 15.0841 9.58144 14 12.1597 14C14.6441 14 16.8933 15.0066 18.5218 16.6342C19.4526 15.3267 20 13.7273 20 12C20 7.58172 16.4183 4 12 4ZM12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5ZM12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7Z"></path>
              </svg>
            </button>
          }
          <mat-menu panelClass="mat-menu-box" #accountMenu="matMenu">
            <button (click)="onClickWishlist()" mat-menu-item>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="currentColor">
                <path
                  d="M12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853ZM18.827 6.1701C17.3279 4.66794 14.9076 4.60701 13.337 6.01687L12.0019 7.21524L10.6661 6.01781C9.09098 4.60597 6.67506 4.66808 5.17157 6.17157C3.68183 7.66131 3.60704 10.0473 4.97993 11.6232L11.9999 18.6543L19.0201 11.6232C20.3935 10.0467 20.319 7.66525 18.827 6.1701Z"></path>
              </svg>
              <span style="font-size: 16px">Wishlist</span>
              <span
                style="margin-bottom: 20px"
                matBadge="15"
                matBadgeColor="warn"
                [matBadge]="wishlistCount > 9 ? '9+' : wishlistCount"
                [matBadgeHidden]="wishlistCount === 0 || wishlistCount < 1"
                matBadgeOverlap="false"
                matBadgePosition="after">
              </span>
            </button>
            <button mat-menu-item [routerLink]="['/orders']">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="currentColor">
                <path
                  d="M8 4H21V6H8V4ZM3 3.5H6V6.5H3V3.5ZM3 10.5H6V13.5H3V10.5ZM3 17.5H6V20.5H3V17.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z"></path>
              </svg>
              <span style="font-size: 16px">Orders</span>
            </button>
            <button mat-menu-item (click)="myAccount()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="currentColor">
                <path
                  d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.1597 16C10.1243 16 8.29182 16.8687 7.01276 18.2556C8.38039 19.3474 10.114 20 12 20C13.9695 20 15.7727 19.2883 17.1666 18.1081C15.8956 16.8074 14.1219 16 12.1597 16ZM12 4C7.58172 4 4 7.58172 4 12C4 13.8106 4.6015 15.4807 5.61557 16.8214C7.25639 15.0841 9.58144 14 12.1597 14C14.6441 14 16.8933 15.0066 18.5218 16.6342C19.4526 15.3267 20 13.7273 20 12C20 7.58172 16.4183 4 12 4ZM12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5ZM12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7Z"></path>
              </svg>
              <span style="font-size: 16px">Account</span>
            </button>
            <button mat-menu-item (click)="onSignout()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="currentColor">
                <path
                  d="M4 18H6V20H18V4H6V6H4V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V18ZM6 11H13V13H6V16L1 12L6 8V11Z"></path>
              </svg>
              <span>Sign out</span>
            </button>
          </mat-menu>
        </div>
      </header>
    }
    <div class="mobile-menu-active clickalbe-sidebar-wrapper">
      <div class="mobile-sidebar-bar">
        <h2>Categories</h2>
        <a id="close-menu" class="sidebar-close">
          <i class="icofont-close-line"></i>
        </a>
      </div>
      <div style="height: 100%; overflow: auto mb-10">
        <ul class="navbar-nav">
          @for (item of categoryArray; track item) {
            <li (click)="onCloseMenu()" class="nav-item">
              <a
                class="nav-link"
                [ngClass]="{ active: item._id === selectedIndex }"
                (click)="updateQueryParam(item._id, item.subCategoriesInfo[0]._id)">
                {{ item.categoryName.toLowerCase() }}
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
    @if (!hideHeaderFooter) {
      <div
        class="router-outlet"
        [ngClass]="{ 'logged-padding': loggedIn, 'is-cart-checkout': isCartOrCheckout }">
        <router-outlet></router-outlet>
      </div>
    } @else {
      <router-outlet></router-outlet>
    }
    @if (!hideHeaderFooter) {
      <footer class="footer-container">
        <div [style.background-color]="primaryColor" class="inside-section">
          <div class="card-section">
            <img [src]="data.footerLogoLink" alt="footer-logo" />
            <b>WAREHOUSE ADDRESS</b>
            <ul>
              <li>
                <i class="ri-building-3-line"></i>
                {{ data.address }}
              </li>
            </ul>
          </div>
          <div class="card-section" [style.background-color]="primaryColor">
            <b>{{ data.name }} - THE STORE</b>
            <ul>
              @if (data.storeAddress) {
                <li>
                  <i class="ri-home-2-line"></i>
                  {{ data.storeAddress }}
                </li>
              }
              @if (data.storeEmail) {
                <li>
                  <i class="ri-mail-line"></i>
                  <a href="mailto: {{ data.storeEmail }}">
                    {{ data.storeEmail }}
                  </a>
                </li>
              }
              <li>
                <i class="ri-map-pin-2-line"></i>
                <a (click)="onMapInfo(data.long_text, data.lat_text)" target="_blank"> Location </a>
              </li>
            </ul>
          </div>
          <div class="card-section" [style.background-color]="primaryColor">
            <b>CUSTOMER CARE</b>
            <ul>
              @if (data?.contactNumber) {
                <li>
                  <i class="ri-phone-line"></i>
                  <a href="tel: +{{ data.contactNumber }}"> Call Us: +{{ data.contactNumber }} </a>
                </li>
              }
              @if (data?.contactNumber) {
                <li>
                  <i class="ri-whatsapp-line"></i>
                  <a href="https://wa.me/{{ data.contactNumber }}">Message on WhatsApp</a>
                </li>
              }
              @if (data?.email) {
                <li>
                  <i class="ri-mail-line"></i>
                  <a href="mailto: {{ data.email }}">
                    {{ data.email }}
                  </a>
                </li>
              }
              <li>
                <i class="ri-questionnaire-line"></i>
                <a>FAQ</a>
              </li>
              <li>
                <i class="ri-git-repository-private-fill"></i>
                <a>Privacy Policy</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="copy-right-section" [style.background-color]="secondaryColor">
          <span class="year">© {{ currentYear }} {{ data.name }}. All right reserved.</span>
          <div class="powered-by">
            <p class="first">
              Powered by
              <a target="_blank" href="https://www.xlayer.in"> xLayer Technologies&#174; </a>
            </p>
            <p>Build: {{ buildVersion }}</p>
          </div>
        </div>
      </footer>
    }
    @if (screenWidth <= 820 && !hideCart) {
      <div
        (click)="onCheckoutClick()"
        class="mobile-cart-containar"
        [ngClass]="cartItemCount > 0 ? 'active' : ''">
        <div class="cart-info">
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="white">
              <path
                d="M4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V15H18.4433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z"></path>
            </svg>
          </div>
          <div class="content">
            <small>{{ cartItemCount }} items</small>
            <p>{{ cartItemPrice | currency: 'INR' }}</p>
          </div>
        </div>
        <button>
          View Cart
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="currentColor">
            <path
              d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
          </svg>
        </button>
      </div>
    }
  </div>
}
